import React from 'react';

function NoResults({ searchTerm, resourcedTexts }) {
    return (
        <div className="no-results">
            {searchTerm ? (
                <>
                    <h2>
                        {resourcedTexts.noResultsWithSearchTermTitle} ‘{searchTerm}’
                    </h2>
                    <p>{resourcedTexts.noResultsWithSearchTermText}</p>
                </>
            ) : (
                <>
                    <h2>{resourcedTexts.noResultsWithoutSearchTermTitle}</h2>
                    <p>{resourcedTexts.noResultsWithoutSearchTermText}</p>
                </>
            )}
        </div>
    );
}

export { NoResults };
